import * as types from '../mutation-types'
import pricesRepository from '../../api/pricesRepository'

const state = {
  arePricesChanged: false
}

const getters = {
  arePricesChanged: state => state.arePricesChanged
}

const actions = {
  changePrices ({commit}, prices) {
    return pricesRepository.changePrices(prices).then((response) => {
      if (response.data.success) {
        commit(types.SET_PRICES_CHANGED, true)
      } else {
        commit(types.SET_PRICES_CHANGED, false)
      }
    })
  }
}

const mutations = {
  [types.SET_PRICES_CHANGED] (state, payload) {
    state.arePricesChanged = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
